<div
    class="stat-item position-relative"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <h5>
        {{ 'CO2_Savings_This_Year' | translate}}
    </h5>
    <div class="number lh-1 fw-medium">
        {{ '135' | cultural }} kg
    </div>
    <span class="daxa-up-down-badge down position-relative">
        <i class="material-symbols-outlined">
            trending_down
        </i>
        {{ '1.25' | cultural }}%
    </span>
    <div class="chart">
        <div id="crm_lead_conversation_chart"></div>
        <div class="title d-block text-body">
            {{ 'This_Year' | translate }}
        </div>
    </div>
</div>